import { Actions, Module, Mutations } from 'vuex-smart-module'

import type { CaptchaCheckRequest, Captcha } from '@/api'

import { CaptchaService } from '@/api'
import { loading as loadingModule, LoadingGetters } from '@/store/modules/loading'

const loading = loadingModule.clone()

export class CaptchaState {}

export class CaptchaGetters extends LoadingGetters<CaptchaActions, CaptchaState> {
  get isGenerateCaptcha() {
    return this.state.loading.loaders.generateCaptcha
  }
  get isValidateCaptcha() {
    return this.state.loading.loaders.validateCaptcha
  }
}

export class CaptchaMutations extends Mutations<CaptchaState> {}

export class CaptchaActions extends Actions<CaptchaState, CaptchaGetters, CaptchaMutations, CaptchaActions> {
  async generateCaptcha(): Promise<Captcha> {
    return await CaptchaService.generateCaptcha()
  }
  async validateCaptcha(captcha: CaptchaCheckRequest): Promise<void> {
    return await CaptchaService.validateCaptcha(captcha)
  }
}

export type CaptchaModules = {
  loading: typeof loading
}

export const captcha = new Module<CaptchaState, CaptchaGetters, CaptchaMutations, CaptchaActions, CaptchaModules>({
  state: CaptchaState,
  getters: CaptchaGetters,
  mutations: CaptchaMutations,
  actions: CaptchaActions,
  modules: {
    loading,
  },
})
